import {
  OnDemandPlaylistEntity,
  OnDemandVideoEntity,
} from "@citychallenge/api-public";
import { OnDemandVideoModel } from "./on-demand-video.model";

export class OnDemandPlaylistModel
  implements
    Omit<OnDemandPlaylistEntity, "company" | "videos" | "playlistDivisions">
{
  public id!: string;
  public name!: string;
  public videos: OnDemandVideoModel[];

  constructor(data: OnDemandPlaylistEntity) {
    this.id = data.id;
    this.name = data.name;
    this.videos = ((data.videos as unknown as OnDemandVideoEntity[]) || [])
      .map((video) => new OnDemandVideoModel(video))
      .sort((a, b) => (a.weight || 0) - (b.weight || 0));
  }
}
